import { render } from "./AdminFAQ.vue?vue&type=template&id=74b166fe"
import script from "./AdminFAQ.vue?vue&type=script&lang=js"
export * from "./AdminFAQ.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__